import { textTinyLight } from '@hud/web-components/DesignSystem/Typography';
import { themeColor } from '@hud/web-components/theme/colors';
import styled from 'styled-components';

export const FormattedRuns = styled.div`
  .totalRuns {
    display: inline-block;
  }

  .normalizedRuns {
    ${textTinyLight};
    display: inline-block;
    min-width: 60px;
    color: ${themeColor('textSecondary')};
`;
